import { RouteRecordRaw } from 'vue-router'

const patient: Array<RouteRecordRaw> = [{
    path: '/patient',
    meta: {
        title: "患者管理"
    },
    component: () => import("@/views/patient/team.vue")
}, {
    path: '/patient/list',
    meta: {
        title: "成员列表"
    },
    component: () => import("@/views/patient/list.vue")
}, {
    path: '/patient/archive',
    meta: {
        title: "案例管理"
    },
    component: () => import("@/views/patient/archive.vue")
}];
export default patient;